module.exports = __webpack_public_path__ + "static/media/batman.21a20ce1.jpg";